export interface SavingsCapacityExtraordinaryItemGroupDto {
	type: ExtraOrdinaryItemGroupType
	items: SavingsCapacityExtraordinaryItemDto[]
	notes: string
}

export type SavingsCapacityExtraordinaryItemDto =
	| SavingsCapacityExtraordinaryTransactionItemDto
	| SavingsCapacityExtraordinaryManualItemDto

export type SavingsCapacityExtraordinaryManualItemDto = {
	type: 'manual'
	amount: number
	description: string
	startDate: Date
	endDate?: Date
}

export type SavingsCapacityExtraordinaryTransactionItemDto = {
	type: 'transaction'
	amount: number
	description: string
	categoryId: number
	categoryName: string
	transactionId: string
	transactionDate: Date
}

export interface TransactionOutputCategoryDto {
	id: number
	description: string
}

export interface TransactionOutputApplicantTransactionDto {
	text: string
	dateTime: Date
	amount: number
	id: string
	category: TransactionOutputCategoryDto
}

export const extraOrdinaryItemGroups = {
	homeImprovement: [490, 106, 390, 467, 42, 58, 62, 391, 478, 0, 462],
	largeCelebrations: [497, 370, 471, 492, 458, 466, 27, 159, 398, 0, 462, 518],
	unusualTravels: [36, 1, 131, 138, 373, 399, 400, 425, 0, 518],
	largeLeisurelyPurchases: [
		62, 80, 402, 403, 114, 475, 477, 479, 485, 486, 511, 512, 506, 0,
	],
	otherExtraordinaryExpenses: [53, 49, 100, 487, 502, 494, 26, 469, 0, 462, 518],
} as const

export type ExtraOrdinaryItemGroupType = keyof typeof extraOrdinaryItemGroups

export const ExtraOrdinaryItemGroupTypes = Object.keys(
	extraOrdinaryItemGroups,
) as ExtraOrdinaryItemGroupType[]